/**
 * Marquee Widget - Start animation on viewport entrance
 */
( function() {
    'use strict';

    function initMarquee() {
        const marquees = document.querySelectorAll( '.marquee-widget__container' );
        if ( ! marquees.length ) {
            return;
        }

        const observedMarquees = new Set();

        const observer = new IntersectionObserver( ( entries ) => {
            entries.forEach( ( entry ) => {
                // Add animation only once when element enters viewport
                if ( entry.isIntersecting && ! observedMarquees.has( entry.target ) ) {
                    entry.target.classList.add( 'is-visible' );
                    observedMarquees.add( entry.target );
                }
            } );
        }, {
            threshold: 0,
        } );

        marquees.forEach( ( marquee ) => {
            observer.observe( marquee );
        } );
    }

    // Initialize on DOM ready
    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', initMarquee );
    } else {
        initMarquee();
    }

    // Reinitialize on responsive resize
    window.addEventListener('responsiveResize', initMarquee);

    // Re-initialize on Elementor live edit
    if ( window.elementorFrontend ) {
        window.elementorFrontend.hooks.addAction(
            'frontend/element_ready/db_marquee.default',
            initMarquee
        );
    }
} )();
